import { string } from 'prop-types'

import { Typography, Notification } from '@telus-uds/components-web'
import useTranslate from '../../../../hooks/useTranslate'

export const PromoCodeNotification = ({ promoCode, currentEvent }) => {
  const translate = useTranslate()

  return (
    <Notification variant={{ validation: 'success' }} dismissible testID="promo-code-notification">
      <Typography variant={{ size: 'medium' }}>
        {translate(`appNotification.promoCode.${currentEvent}.successNotification`, true)}{' '}
        <Typography variant={{ size: 'medium' }} fontWeight="bold">
          {translate(`appNotification.promoCode.${currentEvent}.promoCode`, {
            replacements: {
              promoCode
            }
          })}
        </Typography>{' '}
        {translate(`appNotification.promoCode.${currentEvent}.details`, true)}
      </Typography>
    </Notification>
  )
}

PromoCodeNotification.propTypes = {
  promoCode: string.isRequired,
  currentEvent: string.isRequired
}
